<template>
  <div>        
    <h1>Welcome to Weizhe's Page</h1>        
  </div>  
</template>

<script setup lang="ts">


</script>